<template>
  <div class="you-and-me-text" :class="[textStyle,mapSize,mapLayout,$root.env]">
    <div class="main" :class="[textStyle,mapSize,mapLayout,$root.env]">
      <div class="first-wrapper letter-wrapper">
        <div class="first letter">
          <TxContent :content="firstLetter"></TxContent>
        </div>
        <div class="ampersand">&</div>
      </div>
      <div class="second-wrapper letter-wrapper">
        <div class="second letter">
          <TxContent :content="secondLetter"></TxContent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YouAndMeTextModule from '../store-mixin'
import YouAndMeTextMixin from "../mixins/you-and-me-text.mixin";

export default {
  name: 'YouAndMeText',
  mixins: [YouAndMeTextModule(), YouAndMeTextMixin()],
}
</script>

<style lang="scss">

//Dont forget to add or change fonts in shopkeeper-child/include/textArtProducts/assets/fonts

@font-face {
  font-family: 'Aguero Serif Free';
  src: url('../assets/fonts/aguero_serif_italic-webfont.eot');
  src: url('../assets/fonts/aguero_serif_italic-webfont.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/aguero_serif_italic-webfont.woff2') format('woff2'),
  url('../assets/fonts/aguero_serif_italic-webfont.woff') format('woff'),
  url('../assets/fonts/aguero_serif_italic-webfont.ttf') format('truetype'),
  url('../assets/fonts/aguero_serif_italic-webfont.svg#aguero_serif_freeitalic') format('svg');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Aguero Serif Free';
  src: url('../assets/fonts/aguero_serif-webfont.eot');
  src: url('../assets/fonts/aguero_serif-webfont.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/aguero_serif-webfont.woff2') format('woff2'),
  url('../assets/fonts/aguero_serif-webfont.woff') format('woff'),
  url('../assets/fonts/aguero_serif-webfont.ttf') format('truetype'),
  url('../assets/fonts/aguero_serif-webfont.svg#aguero_serif_freeregular') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Didot';
  src: url('../assets/fonts/gfsdidot-regular-webfont.eot');
  src: url('../assets/fonts/gfsdidot-regular-webfont.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/gfsdidot-regular-webfont.woff2') format('woff2'),
  url('../assets/fonts/gfsdidot-regular-webfont.woff') format('woff'),
  url('../assets/fonts/gfsdidot-regular-webfont.ttf') format('truetype'),
  url('../assets/fonts/gfsdidot-regular-webfont.svg#gfs_didotregular') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Bodoni-72';
  src: url('../assets/fonts/Bodoni-72-Book.eot');
  src: url('../assets/fonts/Bodoni-72-Book.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/Bodoni-72-Book.woff2') format('woff2'),
  url('../assets/fonts/Bodoni-72-Book.woff') format('woff'),
  url('../assets/fonts/Bodoni-72-Book.ttf') format('truetype'),
  url('../assets/fonts/Bodoni-72-Book.svg#Bodoni-72-Book') format('svg');
}

</style>

<style lang="scss" scoped>
.you-and-me-text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  .main {
    align-items: flex-end;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 170px;
    height: 1010px;

    & > div {
      vertical-align: bottom;
    }
  }

  .letter {
    color: #000000;
    font-family: 'Aguero Serif Free';
    font-style: normal;
    font-size: 760px;
    line-height: 660px;

    &-wrapper {

    }

    &.first {
      margin-bottom: 189px;
      text-align: right;
    }

    &.second {
      text-align: left;
      margin-left: -2px;

    }
  }

  .first-wrapper {
    margin-right: -68px;
    position: relative;
  }

  .second-wrapper {

  }

  .ampersand {
    color: #000000;
    font-family: 'Didot';
    font-size: 220px;
    line-height: 200px;
    position: absolute;
    bottom: 98px;
    /*left: 61px;*/
    right: 40px;
    text-align: left;
  }

}
</style>

